import configJson from './config.json'

export default {
    debug: configJson.debug || true,
    apiUrl: configJson.apiUrl || 'https://localhost:8888/intranet',
    authApiUrl: configJson.authApiUrl || 'https://localhost:8888/sso/'
}